module.exports = __webpack_public_path__ + "static/media/suzhou.f24d4dd2.jpg";